import { theme } from '$/components/Layout/theme';
import tinycolor, { ColorInput } from 'tinycolor2';
import { hash } from './string';
export * from '$/shared/frontend/utils/tinyColor';
import { colorWithAlpha } from '$/shared/frontend/utils/tinyColor';

export const hexToRGBA = (color: tinycolor.ColorInput): tinycolor.ColorFormats.RGBA => {
  return tinycolor(color).toRgb();
};

export const RGBToHex = (color: tinycolor.ColorInput): string => {
  return tinycolor(color).toHex8String();
};

export const darkenColor = (color: string, percent = 10): string => {
  return tinycolor(color).darken(percent).toHex8String();
};

export const darkenColorMinimum = (hex: string, maxLuminance = 0.4): string => {
  let color = tinycolor(hex);
  const lum = color.getLuminance();

  if (lum > maxLuminance) {
    color = color.darken((lum - maxLuminance) * 100);
  }

  return color.toHex8String();
};

export const stringToColor = (
  value: string,
  saturation = 100,
  lightness = 75
): { bg: string; fg: string } => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0; // Convert to 32bit integer
  }

  const color = `hsl(${hash % 360}, ${saturation}%, ${lightness}%)`;

  return {
    bg: colorWithAlpha(color, 0.2),
    fg: darkenColorMinimum(colorWithAlpha(color, 1), 0.2),
  };
};

/**
 * Get color by tag name
 *
 * fg: dark, fgIcon: medium, bg: light
 * @param tag
 * @returns
 */
export const tagColor = (tag: string): { bg: string; fg: string; fgIcon: string } => {
  const hashNo = hash(tag);

  // const tagColors = Object.values(theme.colors.tags);
  // gray and black are not used for tags, so we skip them
  // const color = tagColors[hashNo % Object.keys(tagColors).length - 2] as {
  //   dark: string;
  //   medium: string;
  //   light: string;
  // };
  // return {
  //   bg: color.light,
  //   fg: color.dark,
  //   fgIcon: color.medium,
  // };

  // TODO: Use rainbow colors for tags for this release
  const color = theme.colors.rainbow[hashNo % Object.keys(theme.colors.rainbow).length];

  return {
    bg: colorWithAlpha(color, 0.2),
    fg: darkenColorMinimum(colorWithAlpha(color, 1), 0.2),
    fgIcon: darkenColorMinimum(colorWithAlpha(color, 1), 0.2),
  };
};

/**
 * Get tag color by index to use for Poll and Quiz result
 *
 * fg: dark, fgIcon: medium, bg: light
 * @param idx
 * @returns
 */
export const tagColorByIndex = (idx: number): { bg: string; fg: string; fgIcon: string } => {
  const tagColors = Object.values(theme.colors.tags);
  const color = tagColors[idx % Object.keys(tagColors).length] as {
    dark: string;
    medium: string;
    light: string;
  };
  return {
    bg: color.light,
    fg: color.dark,
    fgIcon: color.medium,
  };
};

export const isSameColor = (color1: ColorInput, color2: ColorInput): boolean => {
  return tinycolor(color1).toHexString() === tinycolor(color2).toHexString();
};

// Note 50 seems like a good threshold to see if a color is the same/similar to another
// color.  So colorDistance < 50 => similar enough
export function colorDistance(c1: tinycolor.Instance, c2: tinycolor.Instance): number {
  const e1 = c1.toRgb();
  const e2 = c2.toRgb();

  const rmean = (e1.r + e2.r) / 2;
  const r = e1.r - e2.r;
  const g = e1.g - e2.g;
  const b = e1.b - e2.b;

  return Math.sqrt((((512 + rmean) * r * r) >> 8) + 4 * g * g + (((767 - rmean) * b * b) >> 8));
}
